import { registeredTabsHandlers } from '@/global/components/view-layouts/tabs-layout/common/registered-tabs-handlers'
import { dateService, FORMATS } from '@/global/services/date'
import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { api } from '@/global/services/api'
import { makeFormData } from '../../helpers/formData'
import gridView from '@/global/components/grid/GridView.vue'
import vehicleInspectionsGridBlock from './VehicleInspectionsGridBlock.vue'
import vehicleInspectionMixin from '../../mixins/vehicleInspectionMixin'
import truncatedTextDisplay from '@/global/components/TruncatedTextDisplay.vue'
import { showDetailsAction, deleteAction, activationAction } from '@/global/components/table/helpers/tableActions'
import { getBooleanFromValue } from '@/global/utils/utils'
export default {
  name: 'Inspections',

  mixins: [
    vehicleInspectionMixin
  ],

  data () {
    return {
      showInspectionsTable: true,
      showInspectionsDetails: false,
      inspectionDetailsTitle: this.$t('fleet/vehicle.inspection'),
      inspectionDetailsBaseTitle: this.$t('fleet/vehicle.inspection'),
      inspectionEditState: false,
      inspectionCreateModeState: false,
      inspectionValidationErrors: {},
      inspectionPermissions: {}
    }
  },

  computed: {
    inspectionsConfig () {
      return {
        title: this.$t('fleet/vehicle_inspection.inspections'),
        key: 'inspections',
        visible: getBooleanFromValue(this.permissions?.canReadVehicleInspection),
        validationErrors: this.inspectionValidationErrors,
        onTabChange: () => {
          this.showMainEditButtons = false
        },
        editUpdate: (event) => {
          const { edit } = event || {}
          this.inspectionEditState = !!edit
        },
        createModeUpdate: (event) => {
          const { createMode } = event || {}
          this.inspectionCreateModeState = !!createMode
        },
        tabContent: [
          // table view
          {
            component: this.tableGridComponent,
            visible: this.showInspectionsTable,
            apiConfig: {
              get: {
                module: 'fleet',
                route: 'vehicle-inspection',
                queryParams: {
                  vehicle_id: this.$route.params.id
                }
              }
            },
            rowDblClick: (event) => this.showInspectionEdit(event),
            mobileConfig: {
              title: this.$t('fleet/vehicle_inspection.inspections')
            },
            title_and_back_config: {
              title: this.$t('fleet/vehicle_inspection.inspections')
            },
            search_and_buttons_config: {
              newClick: () => this.onNewInspection(),
              showNewBtn: getBooleanFromValue(this.inspectionPermissions?.canCreate)
            },
            gridConfig: {
              component: gridView,
              blockConfig: {
                component: vehicleInspectionsGridBlock,
                showDetails: () => {
                  this.showInspectionsTable = false
                  this.showInspectionsDetails = true
                },
                setDetailsTitle: (val) => {
                  this.inspectionDetailsTitle = val
                }
              },
              useBorder: false
            },
            onDataReceivedWithParams: (event) => {
              this.inspectionPermissions = event?.data?.meta?.permissions || {}
            },
            tableConfig: {
              cellsConfig: {
                inspection_date: {
                  custom_display_value: (item) => {
                    return item?.inspection_date ? dateService.formatFromUtc(item.inspection_date, FORMATS.date) : ''
                  }
                },
                valid_until: {
                  custom_display_value: (item) => {
                    return item?.valid_until ? dateService.formatFromUtc(item.valid_until, FORMATS.date) : ''
                  }
                },
                alarm_on: {
                  style: {
                    justifyItems: 'center'
                  }
                },
                images: {
                  wrapperStyle: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'start'
                  }
                }
              },
              headers: [
                {
                  label: this.$t('fleet/vehicle_inspection.inspection_date'),
                  key: 'inspection_date',
                  always_visible: true
                },
                {
                  label: this.$t('fleet/vehicle_inspection.valid_until'),
                  key: 'valid_until',
                  always_visible: true
                },
                {
                  label: this.$t('fleet/vehicle_inspection.inspection_location'),
                  key: 'inspection_location',
                  always_visible: true
                },
                {
                  label: this.$t('fleet/vehicle_inspection.note'),
                  key: 'note',
                  component: truncatedTextDisplay,
                  always_visible: true
                },
                {
                  label: this.$t('fleet/vehicle_inspection.images'),
                  key: 'images',
                  always_visible: true,
                  component: this.tableImageIconWithCounterComponent,
                  disableDefaultClick: true,
                  onClick: (event) => {
                    this.showFilesPreviewDialog({
                      ...event,
                      fieldKey: 'images',
                      removeApiConfig: {
                        module: 'fleet',
                        route: 'vehicle-inspection/remove-image/'
                      }
                    }, 'image', 'inspections')
                  }
                },
                {
                  label: this.$t('fleet/vehicle_inspection.status'),
                  key: 'status',
                  always_visible: true,
                  component: this.activeIconComponent
                },
                {
                  label: this.$t('fleet/vehicle_inspection.alarm_on'),
                  key: 'alarm_on',
                  always_visible: true,
                  component: this.cellIconComponent,
                  style: {
                    textAlign: 'center'
                  },
                  src: (event) => {
                    const { data } = event || {}
                    return data === 1 ? '/img/icons/green-check-circle.svg' : '/img/icons/grey-check-circle.svg'
                  }
                }
              ],
              actionsConfig: [
                showDetailsAction(this.$t, (event) => this.showInspectionEdit(event), { visible: getBooleanFromValue(this.inspectionPermissions?.canRead) }),
                activationAction(this.$t, (event) => this.onInspectionActivation(event), (event) => !!event?.data?.status),
                deleteAction(this.$t, (event) => this.onInspectionDelete(event), { visible: getBooleanFromValue(this.inspectionPermissions?.canDelete) })
              ],
              paginationConfig: {
                perPageOptions: [50, 100]
              },
              filtersConfig: {
                fields: [
                  {
                    key: 'inspection_date',
                    label: this.$t('fleet/vehicle_inspection.inspection_date'),
                    type: 'datetime-picker',
                    subType: 'date',
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.date,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'valid_until',
                    label: this.$t('fleet/vehicle_inspection.valid_until'),
                    type: 'datetime-picker',
                    subType: 'date',
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.date,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'inspection_location',
                    label: this.$t('fleet/vehicle_inspection.inspection_location'),
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'note',
                    label: this.$t('fleet/vehicle_inspection.note'),
                    visible: true,
                    editable: true
                  }
                ]
              }
            }
          },
          // details view
          {
            component: this.tabActionsComponent,
            visible: this.showInspectionsDetails,
            title: this.inspectionDetailsTitle,
            showEditButtons: true,
            showEditBtn: getBooleanFromValue(this.inspectionPermissions?.canUpdate),
            showBackButton: {
              onGoBack: () => this.exitFromInspectionDetails()
            },
            onCancelTabSave: () => this.exitFromInspectionDetails(true),
            onSaveClick: () => this.onSaveInspection()
          },
          {
            component: this.columnsContentComponent,
            visible: this.showInspectionsDetails,
            showBackButton: {
              useChangesNotSavedDialog: false
            },
            rows: [
              {
                disabled: !getBooleanFromValue(this.inspectionPermissions?.canUpdate),
                columnsCount: 3,
                fields: [
                  {
                    key: 'inspection_date',
                    label: this.$t('fleet/vehicle_inspection.inspection_date'),
                    type: 'datetime-picker',
                    subType: 'date',
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.date,
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.date, true)) {
                        updateValidationErrors({
                          inspection_date: this.$t('base.invalid_date').replace(':format', FORMATS.date)
                        })
                      }
                    },
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'valid_until',
                    label: this.$t('fleet/vehicle_inspection.valid_until'),
                    type: 'datetime-picker',
                    subType: 'date',
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.date,
                    onInput: (value, event) => {
                      const { updateValidationErrors } = event || {}

                      if (value && typeof updateValidationErrors === 'function' && !dateService.isValid(value, FORMATS.date, true)) {
                        updateValidationErrors({
                          valid_until: this.$t('base.invalid_date').replace(':format', FORMATS.date)
                        })
                      }
                    },
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'inspection_location',
                    label: this.$t('fleet/vehicle_inspection.inspection_location'),
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'images',
                    label: this.$t('fleet/vehicle/documents_tab.uploaded_images_label'),
                    type: 'files_preview',
                    subtype: 'image',
                    src: '/img/icons/table-image-icon.svg',
                    click: (event) => {
                      this.showFilesPreviewDialog({
                        ...event,
                        fieldKey: 'images',
                        removeApiConfig: {
                          module: 'fleet',
                          route: 'vehicle-inspection/remove-image/'
                        }
                      }, 'image', 'inspections')
                    },
                    visible: !this.inspectionEditState && !this.inspectionCreateModeState,
                    editable: true
                  },
                  {
                    key: 'images_upload',
                    label: this.$t('fleet/vehicle_document.images'),
                    type: 'files_upload',
                    subtype: 'image',
                    accept: '/image*',
                    prependInnerIcon: 'mdi-camera',
                    src: '/img/icons/table-image-icon.svg',
                    click: (event) => {
                      this.showFilesPreviewDialog({
                        ...event,
                        fieldKey: 'images_upload'
                      }, 'image', 'inspections')
                    },
                    visible: this.inspectionEditState || this.inspectionCreateModeState,
                    editable: true,
                    readonly: true
                  },
                  {
                    key: 'note',
                    label: this.$t('fleet/vehicle_document.note'),
                    type: 'textarea',
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'alarm_on',
                    label: this.$t('fleet/vehicle_document.alarm_on'),
                    type: 'base-switch',
                    visible: true,
                    editable: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    onNewInspection () {
      const { setCreateMode, clearData } = registeredTabsHandlers?.inspections || {}
      if (typeof setCreateMode === 'function') {
        setCreateMode(true)
      }
      if (typeof clearData === 'function') {
        clearData()
      }
      this.inspectionDetailsTitle = this.$t('fleet/vehicle.new_vehicle_inspection')
      this.showInspectionsTable = false
      this.showInspectionsDetails = true
    },

    exitFromInspectionDetails (canceling = false) {
      const { clearData, setCreateMode, setEditMode, getCreateModeState, cancelSave } = registeredTabsHandlers?.inspections || {}
      let isCreateMode = false
      if (typeof getCreateModeState === 'function') {
        isCreateMode = getCreateModeState()
      }

      if (isCreateMode) {
        this.showInspectionsTable = true
        this.showInspectionsDetails = false

        if (typeof clearData === 'function') {
          clearData()
        }
        if (typeof setCreateMode === 'function') {
          setCreateMode(false)
        }
        if (typeof setEditMode === 'function') {
          setEditMode(false)
        }
      }
      else if (typeof cancelSave === 'function') {
        if (!canceling) {
          this.showInspectionsTable = true
          this.showInspectionsDetails = false
        }

        cancelSave()
      }
      this.inspectionValidationErrors = {}
    },

    async onSaveInspection () {
      try {
        const { getFormData } = registeredTabsHandlers?.inspections || {}
        const { fetchData } = registeredTableHandlers?.inspections || {}
        const { id: vehicleId } = this.$route?.params || {}

        if (!vehicleId) return

        const data = typeof getFormData === 'function' ? getFormData()?.data : {}
        const formData = makeFormData(data,
          ['images_upload'],
          {
            vehicle_id: vehicleId
          },
          {
            inspection_date: {
              fromFormat: FORMATS.date,
              toFormat: FORMATS.isoDate
            },
            valid_until: {
              fromFormat: FORMATS.date,
              toFormat: FORMATS.isoDate
            }
          })

        let apiUrl = 'vehicle-inspection'
        const { id: inspectionId } = data || {}
        if (!this.inspectionCreateModeState && inspectionId) {
          formData.append('_method', 'PATCH')
          apiUrl += `/${inspectionId}`
        }

        await api('fleet').post(apiUrl, formData)
        this.exitFromInspectionDetails()

        if (typeof fetchData === 'function') {
          fetchData()
        }
      }
      catch (exception) {
        this.inspectionValidationErrors = exception?.response?.data?.errors || {}
        console.error(exception)
      }
    }
  }
}
